/**
 * Description: reauired, the file description, reference link, etc.
 * Created Date: 2020-06-24 7:30:23 PM
 * Author: Liu Man <lm@hcttop.com>
 * -----
 * Last Modified: 2020-07-15, 6:14:10 PM
 * Modified By: Zhao xiaoqin <1421739571@qq.com>
 * -----
 * Copyright (c) 2020-2020 hcttop
 * -----
 * HISTORY:
 * Date               By    Comments
 * ------------------ ----  ------------------------------------------
 */

import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/home/Home.vue";
// 关于我们
const About = () => import("../views/about/About.vue");
const Service = () => import("../views/service/DiagitalService.vue");
// 解决方案
const EnterprisesDiagital = () =>
  import("../views/solution/diagital/EnterprisesDiagital.vue");
const WaterDiagital = () => import("../views/solution/water/SolutionWater.vue");
const IndustrialIoT = () => import("../views/solution/IoT/IndustrialIoT.vue");
const SolutionEvnPro = () =>
  import("../views/solution/environment/SolutionEnv.vue");
// 产品中心
const ProductEnterprises = () =>
  import("../views/product/environment/ProductEnterprises.vue");
const ProductWater = () => import("../views/product/water/ProductWater.vue");
const ProductIoT = () => import("../views/product/park/ProductIoT.vue");
// 广纳贤才
const Careers = () => import("../views/careers/Careers.vue");
const ProductDetail = () => import(".././components/product/ProductDetail.vue");

// import ProductContentListEvn from "../views/ProductContentListEvn";
// import ProductContentListWater from "../views/ProductContentListWater";
// import ProductContentListPark from "../views/ProductContentListPark";

// import ProductDetail from "../views/product/ProductDetail";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "home",
    component: Home
  },
  // 关于睿峰华创
  {
    path: "/about",
    name: "about",
    component: About
  },
  // // 解决方案
  // {
  //   path: "/solution",
  //   name: "solution",
  //   redirect: "/solution/wisdom-city",
  //   component: EnterprisesDiagital
  // },
  {
    path: "/digital-service", // 数字化服务
    name: "digital-service",
    component: Service,
    // a meta field
    meta: { requiresAuth: true }
  },
  {
    path: "/enterprises-digital", // 企业数字化
    name: "wisdom-city",
    component: EnterprisesDiagital,
    // a meta field
    meta: { requiresAuth: true }
  },
  {
    path: "/wisdom-env-solution", // 企业数字化
    name: "wisdom-env",
    component: SolutionEvnPro,
    // a meta field
    meta: { requiresAuth: true }
  },
  {
    path: "/water-digital", // 水务数字化
    name: "water-digital",
    component: WaterDiagital,
    // a meta field
    meta: { requiresAuth: true }
  },
  {
    path: "/industrial-iot", // 工业物联网
    name: "industrial-iot",
    component: IndustrialIoT,
    // a meta field
    meta: { requiresAuth: true }
  },
  // 产品中心 --- 主页面
  // {
  //   path: "/product",
  //   name: "product",
  //   redirect: "/product-enterprises"
  // },
  // 产品中心 --- 企业数字化
  {
    path: "/product-enterprises",
    name: "product",
    component: ProductEnterprises
  },
  // 产品中心 --- 水务数字化
  {
    path: "/product-water",
    name: "product",
    component: ProductWater
  },
  // 产品中心 --- 工业物联网
  {
    path: "/product-iot",
    name: "product",
    component: ProductIoT
  },
  // 产品中心 --- 企业数字化 --- 企业数字化详情
  {
    path: "/product-detail",
    name: "product-detail-env",
    component: ProductDetail,
    props: true
  },
  // 产品中心 --- 水务数字化 --- 水务数字化详情
  // {
  //   path: "/product/:name/water-detail",
  //   name: "product-detail-water",
  //   component: ProductDetail,
  //   props: true
  // },
  // // 产品中心 --- 工业物联网 --- 工业物联网详情
  // {
  //   path: "/product/:name/park-detail",
  //   name: "product-detail-park",
  //   component: ProductDetail,
  //   props: true
  // },
  {
    path: "/careers",
    name: "careers",
    component: Careers
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, form, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    }
    if (to.hash) {
      return { selector: to.hash };
    }
    return { x: 0, y: 0 };
  }
});

export default router;
